export const ALLOWED_IMAGESERVER_HOSTNAMES = new Set([
	'img.br.de',
	'download.staging.imageserver.br-staging.de',
	'download.dev.imageserver.br-dev.de',
]);
